<template>
  <div id="location">
    <multiselect
      ref="multiselect"
      v-model.lazy="includedLocations"
      label="name"
      track-by="@id"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @search-change="getLocations"
      :class="{ 'border-bottom-blue': isLocationSet && !isLocationOpened }"
      open-direction="bottom"
      :optionsLimit="20"
      :options="searchResultsLocations"
      :multiple="true"
      :searchable="true"
      :loading="isIncludedLocationsLoading"
      :internal-search="false"
      :allow-empty="false"
      :clear-on-select="false"
      :close-on-select="true"
      :max-height="200"
      :show-no-results="false"
      :hide-selected="true"
      placeholder="Ville, département, code postal"
      @close="setIsLocationOpened(false)"
      @open="setIsLocationOpened(true)"
    >
      <span
        class="caret"
        slot-scope="{ toggle }"
        :class="{ 'border-blue': isLocationSet }"
        @mousedown.prevent.stop="toggle"
        slot="caret"
      ></span>
      <span slot="noResult">Aucun résultat...</span>
      <span slot="noOptions">Tapez pour chercher...</span>
      <span
        @click="closeMultiselect()"
        v-if="isLocationSet"
        class="text-center py-1 border-top bg-blue d-block"
        slot="afterList"
        ><IconSubmit class="icon-sm white"
      /></span>
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span v-if="props.option['@type'] === 'City'"
            ><img class="option__image" :src="require('@/assets/icons/marker.svg')" alt="Ville"
          /></span>
          <span v-if="props.option['@type'] === 'Department'"
            ><img
              class="option__image"
              :src="require('@/assets/icons/department.svg')"
              alt="Département"
          /></span>
          <span class="option__title">{{ props.option.displayName }}</span>
          <span class="opacity-low" v-if="props.option['@type'] === 'Department'">
            Département</span
          >
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import IconSubmit from "@/components/icons/IconSubmit.vue";

import { mapMutations, mapState, mapGetters } from "vuex";
import ApiNoBearer from "@/api/apiNoBearer";
import qs from "qs";
import _ from "lodash";
export default {
  components: {
    Multiselect,
    IconSubmit,
  },
  data() {
    return {
      searchResultsLocations: [],
      searchResultsCities: [],
      isIncludedLocationsLoading: false,
    };
  },
  computed: {
    ...mapState(["isLocationOpened"]),
    ...mapGetters(["isLocationSet"]),
    includedLocations: {
      get() {
        let cities = this.$store.state.userSearch.includedCities;
        let departments = this.$store.state.userSearch.includedDepartments;
        return cities.concat(departments);
      },
      set(locations) {
        let cities = locations.filter(city => city["@type"] == "City");
        let departments = locations.filter(department => department["@type"] == "Department");
        this.$store.commit("SET_INCLUDED_LOCATIONS", { cities, departments });
      },
    },

    getCitiesFromLocations() {
      return this.searchResultsCities.filter(city => city["@type"] == "City");
    },

    getSelectedCitiesIds() {
      return this.includedLocations.filter(l => l["@type"] == "City").map(i => i["@id"]);
    },
    getSelectedDepartmentsIds() {
      return this.includedLocations.filter(l => l["@type"] == "Department").map(i => i["@id"]);
    },
    isMobileDevice() {
      return (
        typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1
      );
    },
  },
  methods: {
    ...mapMutations({
      toggleFilter: "TOGGLE_FILTER",
      setIsLocationOpened: "SET_IS_LOCATION_OPENED",
    }),

    closeMultiselect() {
      this.$refs.multiselect.deactivate();
    },

    getLocations(query) {
      if (typeof window.LIT !== "undefined") {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.isIncludedLocationsLoading = true;
        ApiNoBearer()
          .get("/public/location-autocomplete", {
            params: {
              query: query,
              excludedCitiesIds: this.getSelectedCitiesIds,
              excludedDepartmentsIds: this.getSelectedDepartmentsIds,
            },
            paramsSerializer: params => {
              return qs.stringify(params);
            },
          })
          .then(res => {
            this.searchResultsLocations = res.data["hydra:member"];
            this.isIncludedLocationsLoading = false;
            if (this.isMobileDevice) this.scroll();
          })
          .catch(error => {});
      }, 500);
    },
    focus() {
      this.$refs.multiselect.$el.focus({ preventScroll: true });
    },
    scroll() {
      window.scrollTo({
        top: 220,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    if (this.$router.currentRoute.name != "dashboard") {
      this.focus();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/mixins";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "@/styles/multiselect.scss";
@import "@/styles/transitions.scss";

.option__image {
  width: 1.2rem;
  margin-right: 0.5rem;
}
.multiselect {
  @include media-breakpoint-up(md) {
    width: 22rem;
  }
}
</style>
